<template>

  <v-container fluid class="pa-0">

    <v-row align="center" justify="end" dense no-gutters>
        <v-col md="1" sm="12" xs="12">
          <label class="menunamestyle ml-5">{{this.$session.get("MENUNAME")}}</label>
        </v-col>
        <v-spacer/>
      <template v-if="grade == 99">
        <v-col md="3" sm="12" xs="12" >
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
        <v-col md="3" sm="12" xs="12" >
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
        <v-col md="3" sm="12" xs="12" > 
          <steptypedialog :typename="SEARCH_STEP_NAME" :eventidx="SEARCH_EVENT_IDX" @callback="stepsearchcb"></steptypedialog>
        </v-col>
        <v-col cols="2" md="2" sm="12" xs="12" >
          <v-btn class="search_btn_freesize" outlined large @click="loadpage">{{$t('common_search_list')}}</v-btn>
        </v-col>
    </v-row>

    <v-row dense no-gutters>
      <v-col cols="12" style="background:#f6f6f6;border-width:1px 1px 1px 1px;border-color:#f5f5f5;border-radius:1px;border-style:solid;"/>
    </v-row>

      <v-row>
        <v-col cols="12" md="9" style="background:#f6f6f6;border-width:1px 1px 1px 1px;border-color:#f5f5f5;border-radius:1px;border-style:solid;">
          
          <v-row ref="edit_layout" justify="start" dense no-gutters>

            <v-row dense class="ml-3">
              <v-col cols="3">
                <v-text-field background-color="white" dense outlined height="43" ref="ref_diswidth" :value="DISPLAY_WIDTH" :label="$t('design_label1')" @keydown.enter="changedisplay"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field background-color="white" dense outlined height="43" ref="ref_disheight" :value="DISPLAY_HEIGHT" :label="$t('design_label2')" @keydown.enter="changedisplay"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-btn class="white_blue_btn mr-1" outlined large @click="changedisplay">{{$t('design_label21')}}</v-btn>
              </v-col>
            </v-row>

            <v-spacer/>
            <v-btn :disabled="SEARCH_STEP_IDX == null" class="white_blue_btn mr-1" outlined large @click="savedesign"><v-icon>mdi-download</v-icon>{{$t("common_save")}}</v-btn>
            <v-btn :disabled="SEARCH_STEP_IDX == null" class="white_blue_btn mr-5" outlined large @click="printtest4040"><v-icon>mdi-printer</v-icon>{{$t('design_label4')}}</v-btn>
          </v-row>
          
          <v-row class="mt-5" justify="center" dense no-gutters :style="'z-index:10;position:fixed; top:170px;left:'+(DISPLAY_X+20)+'px'">
            
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="SEARCH_STEP_IDX == null" icon color="#505050" @click="addcomponent" v-bind="attrs" v-on="on"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                </template>
                <span>{{$t("common_insert")}}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="SEARCH_STEP_IDX == null" icon color="#505050" @click="centeralign" v-bind="attrs" v-on="on"><v-icon>mdi-align-horizontal-center</v-icon></v-btn>
                </template>
                <span>{{$t('design_label5')}}</span>
              </v-tooltip>
              
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="SEARCH_STEP_IDX == null" icon color="#505050" @click="fullsize" v-bind="attrs" v-on="on"><v-icon>mdi-arrow-split-vertical</v-icon></v-btn>
                </template>
                <span>{{$t('design_label6')}}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="SEARCH_STEP_IDX == null" icon color="#505050" @click="getfront" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-bring-forward</v-icon></v-btn>
                </template>
                <span>{{$t('design_label7')}}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="SEARCH_STEP_IDX == null" icon color="#505050" @click="pushback" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-send-backward</v-icon></v-btn>
                </template>
                <span>{{$t('design_label8')}}</span>
              </v-tooltip>
            
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="SEARCH_STEP_IDX == null" icon color="#505050" @click="deleteall" v-bind="attrs" v-on="on"><v-icon>mdi-autorenew</v-icon></v-btn>
                </template>
                <span>{{$t('design_label9')}}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="SEARCH_STEP_IDX == null" icon color="#505050" @click="deletedesign" v-bind="attrs" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                </template>
                <span>{{$t('design_label10')}}</span>
              </v-tooltip>

          </v-row>          
          
          <v-row :style="'position:fixed; top:230px;left:'+(DISPLAY_X+30)+'px'">
            <a id="edit_div_label1" class="front_info_label" @click="selectface(true)">{{$t('design_label11')}}</a>
            <div style="width:10px"/>
            <a id="edit_div_label2" class="back_info_label"  @click="selectface(false)">{{$t('design_label12')}}</a>
          </v-row>

          <v-row dense no-gutters justify="center">
            <div id="edit_div_line" :style="'margin-left:20px;width:'+(DISPLAY_WIDTH+6)+'px;height:'+(DISPLAY_HEIGHT+6)+'px;backgroundColor:#808080;overflow:auto;position:absolute;border:solid 3px #4e6ef7;'">
              <div id="edit_div" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;'">
              </div>
            </div> 
            <div id="edit_div_line2" :style="'margin-bottom:100px;margin-left:20px;margin-top:'+(DISPLAY_HEIGHT+40)+'px;width:'+(DISPLAY_WIDTH+6)+'px;height:'+(DISPLAY_HEIGHT+6)+'px;backgroundColor:#808080;overflow:auto;position:absolute;border:solid 3px #e5e5e5;'">
              <div id="edit_div2" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;'">
              </div>
            </div>  
          </v-row>          

        </v-col>


        <v-col cols="12" md="3" v-if="SEARCH_STEP_IDX != null">
          <v-row dense>
            <v-col cols="12">
              <comlayout @callback="selectlayout_com"/>
            </v-col>
            <v-col cols="12">
              <comdesignuser @callback="selectdesign_com"/>
            </v-col>
            <v-col cols="12">
              <comdesignstep @callback="selectdesign_com"/>
            </v-col>
          </v-row>
          
        <template v-if="SELECT_ITEM[0].ISBG == 0">
          <v-row dense class="mt-2 ml-5 mr-5">
            <v-select outlined dense :value="SELECT_ITEM[0].COMPONENT_TYPE" 
            @change="changecomponenttype" :items="COMPONENTTYPELIST" :label="$t('design_label13')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
          </v-row>
        </template>
        <v-row dense class="mt-2 ml-5 mr-5">
          <v-select outlined dense :value="SELECT_ITEM[0].BGTYPE" @change="changebgtype" 
          :items="BGTYPELIST" :label="$t('design_label14')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
        </v-row>

        <template v-if="SELECT_ITEM[0].BGTYPE == 1">
          <v-row dense class="ml-5 mr-5">
            <v-file-input outlined dense accept="image/*" :label="$t('design_label15')" v-model="uploadFile" @change="changefile">
              <!-- <template v-slot:selection>{{ SELECT_ITEM[0].LOCALIMG }}</template> -->
            </v-file-input>
            <template v-if="SELECT_ITEM[0].LOCALIMG != null ">
              <v-btn class="search_btn" small rounded color="primary" @click="uploadimage">{{$t("common_save")}}</v-btn>
            </template>
          </v-row>
        </template>

        <v-row dense class="ml-5 mr-5">
          <comcolor :disabled="SELECT_ITEM[0].BGTYPE == 1" dense ref="bgcolor" :comname="$t('design_label16')" :colorvalue="SELECT_ITEM[0].BGCOLOR" @callback="bgcolorcallback" />
        </v-row>

          <v-row dense class="ml-5 mr-5">
            <comcolor :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" dense ref="textcolor" :comname="$t('design_label17')" :colorvalue="SELECT_ITEM[0].TEXTCOLOR" @callback="textcolorcallback" />
          </v-row>

          <v-row v-if="grade > 90 && SELECT_ITEM[0].ISBG == 0" dense class="ml-5 mr-5">
            <v-checkbox :label="$t('design_label18')" v-model="SELECT_ITEM[0].ISFLIP" @change="changeflip"></v-checkbox>
          </v-row>

          <v-row dense class="ml-5 mr-5 mt-2">
            <v-select outlined :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" dense :value="SELECT_ITEM[0].TEXTALIGN"  @change="changealign" :items="ALIGNTYPELIST" :label="$t('design_label19')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
          </v-row>
          <v-row dense class="ml-2 mr-5">
            <comfont :comidx="this.SEARCH_COM_IDX" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :comname="SELECT_ITEM[0].TEXTFONT" @callback="changefont"/>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_textsize" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTSIZE"  @change="changesize" :label="$t('design_label20')" @keydown.enter="changesize"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" class="ml-2 search_btn" @click="changesize">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-select outlined dense :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTMATCH" @change="changematch" :items="MATCHTYPELIST" :label="$t('design_label22')" item-text="name" item-value="value"/>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-textarea dense outlined height="70" ref="ref_textvalue" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0 || SELECT_ITEM[0].TEXTMATCH != 'INPUT'" 
                :value="SELECT_ITEM[0].TEXTVALUE" @change="changevalue" no-resize :label="$t('design_label23')" @keydown.enter="changevalue"></v-textarea>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" class="ml-2 search_btn" @click="changevalue">{{$t('design_label21')}}</v-btn>
          </v-row>

          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_posx" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_POSX" @change="changeposx" :label="$t('design_label24')" @keydown.enter="changeposx"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changeposx">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_posy" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_POSY" @change="changeposy" :label="$t('design_label25')" @keydown.enter="changeposy"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changeposy">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_width" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_WIDTH" @change="changewidth" :label="$t('design_label26')" @keydown.enter="changewidth"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changewidth">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_height" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_HEIGHT" @change="changeheight" :label="$t('design_label27')" @keydown.enter="changeheight"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changeheight">{{$t('design_label21')}}</v-btn>
          </v-row>
        </v-col>
      </v-row>
      
    
  </v-container>
</template>

<script>
import DRBackground from '../dragndrop/DRBackground.js'
// eslint-disable-next-line no-unused-vars
import DRComponent from '../dragndrop/DRComponent.js'
import DRModel from '../dragndrop/DRModel.js'

  
  export default {

    methods: {
      
      changelayoutsize(){
        this.DISPLAY_X = this.$refs.edit_layout.getBoundingClientRect().x;
      },

      fullsize(){
        if(this.isfront){
          this.drback.fullsize();
        }else{
          this.drback2.fullsize();
        }
      },

      centeralign(){
        if(this.isfront){
          this.drback.centeralign();
        }else{
          this.drback2.centeralign();
        }
      },

      getfront(){
        if(this.isfront){
          this.drback.getfront();
        }else{
          this.drback2.getfront();
        }
      },

      pushback(){
        if(this.isfront){
          this.drback.pushback();
        }else{
          this.drback2.pushback();
        }
      },

      //명찰편집 이벤트
      changeposx(){
        let inputEl = this.$refs.ref_posx.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_POSX = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_POSX = parseInt(ev);
        }
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },
      changeposy(){
        let inputEl = this.$refs.ref_posy.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_POSY = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_POSY = parseInt(ev);
        }
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },
      changewidth(){
        let inputEl = this.$refs.ref_width.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_WIDTH = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_WIDTH = parseInt(ev);
        }
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },
      changeheight(){
        let inputEl = this.$refs.ref_height.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_HEIGHT = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_HEIGHT = parseInt(ev);
        }
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },

      changedisplay(){
        let inputEl1 = this.$refs.ref_diswidth.$el.querySelector('input');
        var ev1 = inputEl1.value;
        if(isNaN(parseInt(ev1))){
          this.DISPLAY_WIDTH = 0;
        }else{
          this.DISPLAY_WIDTH = parseInt(ev1);
        }
        let inputEl2 = this.$refs.ref_disheight.$el.querySelector('input');
        var ev2 = inputEl2.value;
        if(isNaN(parseInt(ev2))){
          this.DISPLAY_HEIGHT = 0;
        }else{
          this.DISPLAY_HEIGHT = parseInt(ev2);
        }

        
        this.drback.setLayoutChange(this.DISPLAY_WIDTH, this.DISPLAY_HEIGHT);
        this.drback2.setLayoutChange(this.DISPLAY_WIDTH, this.DISPLAY_HEIGHT);
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },


      changeflip(){
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },

      changevalue(){
        let inputEl = this.$refs.ref_textvalue.$el.querySelector('textarea');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        this.SELECT_ITEM[0].TEXTVALUE = ev;
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },
      changesize(){
        let inputEl = this.$refs.ref_textsize.$el.querySelector('input');
        var ev = inputEl.value;
        if(ev < 10){
          this.$alert(this.$t('design_msg1'));
          inputEl.value = this.SELECT_ITEM[0].TEXTSIZE;
          return;
        }
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        this.SELECT_ITEM[0].TEXTSIZE = parseInt(ev);
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },
      changealign(ev){
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        this.SELECT_ITEM[0].TEXTALIGN = ev;
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },
      changematch(ev){
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        this.SELECT_ITEM[0].TEXTMATCH = ev;
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },

      changefont(cl){
        //폰트 변경
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        this.SELECT_ITEM[0].TEXTFONT = cl.CODE;
        this.drback.updateComponent();
        this.drback2.updateComponent();
        this.$forceUpdate();
      },

      changebgtype(cl){
        if(this.SELECT_ITEM[0].ISBG == 1){
          if(this.isfront){
            this.drback.saveBGUndo("bginfo");
          }else{
            this.drback2.saveBGUndo("bginfo");
          }
          this.SELECT_ITEM[0].BGTYPE = cl;
          if(this.isfront){
            this.drback.updateBackground(this.SELECT_ITEM[0]);
          }else{
            this.drback2.updateBackground(this.SELECT_ITEM[0]);
          }
        }else{
          this.drback.saveUndo("info");
          this.drback2.saveUndo("info");
          this.SELECT_ITEM[0].BGTYPE = cl;
          this.drback.updateComponent();
          this.drback2.updateComponent();
        }
      },

      changecomponenttype(cl){
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");
        this.SELECT_ITEM[0].COMPONENT_TYPE = cl;
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },

      bgcolorcallback(cl){
        if(this.SELECT_ITEM[0].ISBG == 1){
          //배경 언두 처리
          if(this.isfront){
            this.drback.saveBGUndo("bginfo");
          }else{
            this.drback2.saveBGUndo("bginfo");
          }
          this.SELECT_ITEM[0].BGCOLOR = String(cl).replace("#","");
          if(this.isfront){
            this.drback.updateBackground(this.SELECT_ITEM[0]);
          }else{
            this.drback2.updateBackground(this.SELECT_ITEM[0]);
          }
        }else{
          //언두 저장
          this.drback.saveUndo("info");
          this.drback2.saveUndo("info");
          
          this.SELECT_ITEM[0].BGCOLOR = String(cl).replace("#","");
          
          this.drback.updateComponent();
          this.drback2.updateComponent();
        }

      },

      textcolorcallback(cl){
        //미리 undo를 백업해야함.
        this.drback.saveUndo("info");
        this.drback2.saveUndo("info");

        this.SELECT_ITEM[0].TEXTCOLOR = String(cl).replace("#","");
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },


      //DRBackground가 호출함.
      colorupdate(){
        try{
          this.$refs.bgcolor.updatecolor(this.SELECT_ITEM[0].BGCOLOR);
          this.$refs.textcolor.updatecolor(this.SELECT_ITEM[0].TEXTCOLOR);
        // eslint-disable-next-line no-empty
        }catch(e){
        }
        //이미지
        this.uploadFile = null;
        this.uploadFile = this.SELECT_ITEM[0].LOCALIMG;
        this.$forceUpdate();
      },
      //DRBackground가 호출함. true면 앞면 false면 뒷면
      selectface(flag){
        
        const edit_div_line  = document.getElementById("edit_div_line");
        const edit_div_line2 = document.getElementById("edit_div_line2");
        const edit_div_label1 = document.getElementById("edit_div_label1");
        const edit_div_label2 = document.getElementById("edit_div_label2");
        if(flag){
          this.isfront = true;
          edit_div_line.style.border = "3px #4e6ef7 solid";
          edit_div_line2.style.border = "3px #e5e5e5 solid";
          edit_div_label1.className = "front_info_label";
          edit_div_label2.className = "back_info_label";
          this.drback2.selectCancel();  //프론트 선택시 백 모든 선택 취소
        }else{
          this.isfront = false;
          edit_div_line.style.border = "3px #e5e5e5 solid";
          edit_div_line2.style.border = "3px #4e6ef7 solid";
          edit_div_label1.className = "back_info_label";
          edit_div_label2.className = "front_info_label";
          this.drback.selectCancel();  //백선택시 프론트 모든 선택 취소
        }

      },


      savedesign(){


        //로컬이미지가 있다면 저장 불가.
        var flag = true;
        if(this.drback.back_div.model.LOCALIMG != null){
          flag = false;
        }
        if(this.drback2.back_div.model.LOCALIMG != null){
          flag = false;
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }
        for(var j=0;j<this.drback.back_div.component_list.length;j++){
          if(this.drback.back_div.component_list[j].temp_div.model.LOCALIMG != null){
            flag = false;
            break;
          }
        }
        for(var k=0;k<this.drback2.back_div.component_list.length;k++){
          if(this.drback2.back_div.component_list[k].temp_div.model.LOCALIMG != null){
            flag = false;
            break;
          }
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }
        
        //뉴라인 특수문자 컨버트 처리
        this.drback.back_div.component_list.forEach(cm=>{
            //if(cm.model.COMPONENT_TYPE == 1 && cm.model.TEXTMATCH == "INPUT"){
            if(cm.model.COMPONENT_TYPE == 1){
              cm.model.TEXTVALUE = cm.model.TEXTVALUE.replaceAll("\n", "\\n");
            }
        });
        this.drback2.back_div.component_list.forEach(cm=>{
            if(cm.model.COMPONENT_TYPE == 1){
              cm.model.TEXTVALUE = cm.model.TEXTVALUE.replaceAll("\n", "\\n");
            }
        });

        //객체를 JSON으로 변환하는거 같은데 요고 바꾸자 - ra 
        var temp_obj  = JSON.parse('{"data":[]}');
        var temp_obj2 = JSON.parse('{"data":[]}');

        //배경 컴포넌트 넣어주고
        temp_obj["data"].push(this.drback.back_div.model);
        this.drback.back_div.component_list.forEach(cm=>{
          temp_obj["data"].push(cm.model);
        });
        temp_obj2["data"].push(this.drback2.back_div.model);
        this.drback2.back_div.component_list.forEach(cm=>{
          temp_obj2["data"].push(cm.model);
        });
        
        //json 업로드 체크!
        this.$http.post(this.$host+'/api/DesignInsert',
          {
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: this.SEARCH_EVENT_IDX
            , STEP_IDX: this.SEARCH_STEP_IDX
            , COMPONENT_WIDTH: this.DISPLAY_WIDTH
            , COMPONENT_HEIGHT: this.DISPLAY_HEIGHT
            , COMPONENT: escape(JSON.stringify(temp_obj).replaceAll('\n','\\n'))
            , COMPONENT2: escape(JSON.stringify(temp_obj2).replaceAll('\n','\\n'))
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          this.loading = false;
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.SELECT_DESIGN.COMPONENT   = temp_obj;
            this.SELECT_DESIGN.COMPONENT2  = temp_obj2;

            this.$alert(this.$t('design_msg3'));

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
            this.loading = false;
        });

      },

      deletedesign(){
        this.drback.removeComponent();
        this.drback2.removeComponent();
      },

      deleteall(){

          this.$confirm(this.$t('design_msg4'))
          .then(() => {

            this.$http.post(this.$host+'/api/DesignDelete',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , STEP_IDX  : this.SEARCH_STEP_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t('design_msg5')).then(()=>{
                //BG초기화
                var temp = [
                              {
                                COMPONENT:{ 
                                            data:[ 
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                  ]
                                }
                                ,COMPONENT2:{
                                            data:[
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                 ]
                                }
                              }
                            ];

                var tempobj2 = JSON.parse(JSON.stringify(temp)); //파싱
                this.SELECT_DESIGN = tempobj2[0];
                this.setFace();
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_fail"));
          });      


        });


      },

      changefile(){
        var file = this.uploadFile;
        if (file && file.type.match(/^image\/(png|jpeg)$/)) {

          //배경도 언두 처리 해줘야 하겠지..
          if(this.SELECT_ITEM[0].ISBG == 1){
            if(this.isfront){
              this.drback.saveBGUndo("bginfo");
            }else{
              this.drback2.saveBGUndo("bginfo");
            }
          }else{
            //미리 undo를 백업해야함.
            this.drback.saveUndo("info");
            this.drback2.saveUndo("info");
          }

          var temp = window.URL.createObjectURL(file) //로컬 파일 경로를 가지고 이미지를 보여준다.
          this.SELECT_ITEM[0].IMG = temp;
          this.SELECT_ITEM[0].LOCALIMG = file; //blob 타입
          //갱신
          if(this.SELECT_ITEM[0].ISBG == 1){
            if(this.isfront){
              this.drback.updateBackground(this.SELECT_ITEM[0]);
            }else{
              this.drback2.updateBackground(this.SELECT_ITEM[0]);
            }
          }else{
            this.drback.updateComponent();
            this.drback2.updateComponent();
          }

        }
      },

      uploadimage(){

        if(this.SELECT_ITEM[0].LOCALIMG == null){
          this.$alert(this.$t('design_msg7'));
          return;
        }

        const formData = new FormData();
        formData.append("FOLDER", this.SEARCH_COM_IDX+"/stepdesign");
        formData.append("customfile", this.SELECT_ITEM[0].LOCALIMG);
        this.$http.post(this.$host+'/api/UploadImage', formData, {
          headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
        })
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //성공
            const fileurl = result.data.resultData[0].fileurl;
            
            //변경
            this.SELECT_ITEM[0].IMG = fileurl;
            this.SELECT_ITEM[0].LOCALIMG = null;

            //갱신
            if(this.SELECT_ITEM[0].ISBG == 1){
              if(this.isfront){
                this.drback.updateBackground(this.SELECT_ITEM[0]);
              }else{
                this.drback2.updateBackground(this.SELECT_ITEM[0]);
              }
            }else{
              this.drback.updateComponent();
              this.drback2.updateComponent();
            }
            this.uploadFile = null;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }

        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
        });

      },

      addcomponent(){
        const cm = new DRModel();
        const cp = new DRComponent(cm, this.MATCHTYPELIST, false);
        
        if(this.isfront){
          this.drback.addComponent(cp, true);
        }else{
          this.drback2.addComponent(cp, true);
        }
        cp.setMatchTextValue();

      },


      loadpage(){
        
        this.SELECT_DESIGN = null;
        this.items.splice(0, this.items.length);   //데이터 초기화
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        if(this.SEARCH_STEP_IDX == null){
          this.$alert(this.$t('design_msg13'));
          return;
        }

        this.loaddetail();
      },
      initpage(){
          //첫페이지 로드
          this.loadpage();
      },

      loaddetail(){

          //맵핑을 위한 행사입력양식 조회
          this.MATCHTYPELIST.splice(0, this.MATCHTYPELIST.length);   
          this.$http.post(this.$host+'/api/InputEventList',{
                ADMIN_IDX:  this.$session.get("ADMIN_IDX")
              , COM_IDX:    this.SEARCH_COM_IDX
              , EVENT_IDX : this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.useInfo = result.data.useData;
                const list = result.data.resultData;
                this.MATCHTYPELIST.push({name:this.$i18n.locale == 'ko' ? '직접입력' : 'Input', value:"INPUT"});
                list.forEach(element => {
                    this.MATCHTYPELIST.push({name:element.NAME, value:element.INPUT_CODE}); 
                });
                
                this.getInputCustom();

            }else if(result.data.resultCode == 2){
              //로그인 필요
              
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });        
        
      },

      getInputCustom(){

        //스텝디자인 조회
        this.$http.post(this.$host+'/api/DesignDetail',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , STEP_IDX  : this.SEARCH_STEP_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              
              if(result.data.resultData.length == 0){
                //최초인 경우
                var temp = [
                            {
                                COMPONENT:{ 
                                            data:[ 
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                  ]
                                }
                                ,COMPONENT2:{
                                            data:[
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                 ]
                                }
                              }
                            ];

                var tempobj2 = JSON.parse(JSON.stringify(temp)); //파싱
                this.SELECT_DESIGN = tempobj2[0];
                this.DISPLAY_WIDTH  = 384;
                this.DISPLAY_HEIGHT = 463;

              }else{
                var tempobj   = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
                this.SELECT_DESIGN = tempobj[0];
                this.DISPLAY_WIDTH  = this.SELECT_DESIGN.COMPONENT_WIDTH;
                this.DISPLAY_HEIGHT = this.SELECT_DESIGN.COMPONENT_HEIGHT;
              }
              this.setFace();

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
          });


      },

      //명찰의 앞면 뒷면 선택에 따른 미리보기 셋팅
      setFace(){
        //BG초기화
        this.drback.clearBackground();
        this.drback2.clearBackground();
        this.createComponent(this.drback, this.SELECT_DESIGN.COMPONENT.data);
        this.createComponent(this.drback2, this.SELECT_DESIGN.COMPONENT2.data);
      },

      createComponent(bg, list){

        //컴포넌트 생성
        list.forEach(element => {
          
          const model = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.ISFLIP        = element.ISFLIP;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

          model.ZINDEX        = element.ZINDEX;
          model.COMPONENT_TYPE = element.COMPONENT_TYPE;
          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          if(element.ISBG == undefined || element.ISBG == null){
            if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
              model.ISBG = 1; //bg
              //bg는 this.drback에 직접 처리
              bg.updateBackground(model);
              return;
            }else{
              model.ISBG = 0;
              if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                  model.COMPONENT_TYPE = 1; //text
                }else{
                  model.COMPONENT_TYPE = 0; //image
                }
              }
            } 
          }

          if(element.ISBG == 1){
              bg.updateBackground(model);
              return;
          }

          //컴포넌트 객체 생성.
          const component = new DRComponent(model, this.MATCHTYPELIST, false);
          bg.addComponent(component, false);

        });

      },


      selectdesign_com(item){
        this.SELECT_DESIGN = item;
        this.DISPLAY_WIDTH  = item.COMPONENT_WIDTH;
        this.DISPLAY_HEIGHT = item.COMPONENT_HEIGHT;
        this.setFace();
      },

      selectlayout_com(item){

          //부모뷰의 edit_div에 넣는다.
          this.$http.post(this.$host+'/api/LayoutDetail',
            {
                ADMIN_IDX : item.ADMIN_IDX
              , IDX : item.IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              var tempobj    = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
              
              var component  = tempobj[0].COMPONENT;
              this.DISPLAY_WIDTH  = tempobj[0].COMPONENT_WIDTH;
              this.DISPLAY_HEIGHT = tempobj[0].COMPONENT_HEIGHT;

              if(this.isfront){
                this.drback.clearBackground();
                this.createComponent(this.drback, component.data);
              }else{
                this.drback2.clearBackground();
                this.createComponent(this.drback2, component.data);
              }

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
          });


      },


      //출력용 컴포넌트 (input을 div로 생성)
      async createPrintComponent(bg, list){

        //컴포넌트 생성
        for(var i=0;i<list.length;i++){
          
          const element = list[i];

          const model = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.ISFLIP        = element.ISFLIP;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

          model.ZINDEX        = element.ZINDEX;
          model.COMPONENT_TYPE = element.COMPONENT_TYPE;
          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          if(element.ISBG == undefined || element.ISBG == null){
            if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
              model.ISBG = 1; //bg
              //bg는 this.drback에 직접 처리
              bg.updateBackground(model);
              continue;
            }else{
              model.ISBG = 0;
              if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                  model.COMPONENT_TYPE = 1; //text
                }else{
                  model.COMPONENT_TYPE = 0; //image
                }
              }
            } 
          }

          if(element.ISBG == 1){
              bg.updateBackground(model);
              continue;
          }

          //프린트용 컴포넌트 객체 생성.
          const component = new DRComponent(model, this.MATCHTYPELIST, true);
          if(model.COMPONENT_TYPE == 2){
            await component.createQRCODETEMP(component);
          }else if(model.COMPONENT_TYPE == 3){
            await component.createPHOTOTEMP(component);
          }else if(model.COMPONENT_TYPE == 4){
            await component.createBARCODETEMP(component);
          }
          bg.addComponent(component, false);

        }

      },


      getPrintWidth(wpx){
        if(wpx == 384){
          return 102;
        }else if(wpx == 264){
          return 70;
        }else if(wpx == 340){
          return 90;
        }else if(wpx == 793){
          return 210;
        }else{
          return 0;
        }
      },

      getPrintHeight(hpx){
        if(hpx == 603){
          return 160;
        }else if(hpx == 567){
          return 150;
        }else if(hpx == 463){
          return 122.5;
        }else if(hpx == 384){
          return 102;
        }else if(hpx == 313){
          return 83;
        }else if(hpx == 263){
          return 70;
        }else if(hpx == 191){
          return 50;
        }else if(hpx == 642){
          return 170;
        }else if(hpx == 510){
          return 135;

        }else{
          return 0;
        }
      },

      async printtest4040(){
        
        //input은 문제가 된다.. div로 변경해서 출력해야할듯.
        
        const width_mm  = this.getPrintWidth(this.DISPLAY_WIDTH);
        const height_mm = this.getPrintHeight(this.DISPLAY_HEIGHT);
        if(width_mm == 0 || height_mm == 0){
          this.$alert(this.$t("common_size"));
          return;
        }
        
        const top_div = document.createElement("div");

        const temp1 = document.createElement("div");
        temp1.style.height   = `${height_mm}mm`;
        temp1.style.width    = `${width_mm}mm`;
        temp1.style.overflow  = "hidden";

        const temp2 = document.createElement("div");
        temp2.style.height   = `${height_mm}mm`;
        temp2.style.width    = `${width_mm}mm`;
        temp2.style.overflow  = "hidden";
        temp2.style.transform  = "rotate(180deg)";

        const bg = new DRModel();
        bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
        bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
        bg.LAYOUT_POSX    = 0;
        bg.LAYOUT_POSY    = 0;
        bg.ISBG           = 1;  //bg
        bg.COMPONENT_TYPE = 0; 
        bg.BGTYPE = 0;
        bg.BGCOLOR = "FFFFFFFF";
        
        var front  = new DRBackground(bg, {}, this, true);
        var back   = new DRBackground(bg, {}, this, false);
        temp1.appendChild(front.back_div);
        temp2.appendChild(back.back_div);        

        await this.createPrintComponent(front, this.SELECT_DESIGN.COMPONENT.data);
        await this.createPrintComponent(back, this.SELECT_DESIGN.COMPONENT2.data);

        const page_div = document.createElement("div");
        page_div.style.position  = "absolute";
        page_div.style.height    = `${height_mm*2}px`;
        page_div.style.width     = `${width_mm}px`;
        page_div.style.left      = "0px";
        page_div.style.top       = "0px";
        //page_div.style.overflow  = "hidden";

        page_div.appendChild(temp1);
        page_div.appendChild(temp2);

        top_div.appendChild(page_div);
        var printContents = top_div.outerHTML;
        

        var w = window.open();

        //폰트정보 넘겨주기
        this.fontlist.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });

        w.document.write(printContents);
        w.document.write('<scr' + 'ipt type="text/javascript">' + 'window.onload = function() { window.print(); window.close(); };' + '</sc' + 'ript>');
        w.document.body.setAttribute("style", "-webkit-print-color-adjust: exact;");  //이거 해줘야 컬러와 이미지 출력됨.
        w.document.close(); // necessary for IE >= 10
        w.focus();

      },


      async printtest(){

        //input은 문제가 된다.. div로 변경해서 출력해야할듯.
        

        const temp1 = document.createElement("div");
        const temp2 = document.createElement("div");
        const bg = new DRModel();
        bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
        bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
        bg.LAYOUT_POSX    = 0;
        bg.LAYOUT_POSY    = 0;
        bg.ISBG           = 1;  //bg
        bg.COMPONENT_TYPE = 0; 
        bg.BGTYPE = 0;
        bg.BGCOLOR = "FFFFFFFF";
        
        var front  = new DRBackground(bg, {}, this, true);
        var back   = new DRBackground(bg, {}, this, false);
        temp1.appendChild(front.back_div);
        temp2.appendChild(back.back_div);        

        await this.createPrintComponent(front, this.SELECT_DESIGN.COMPONENT.data);
        await this.createPrintComponent(back, this.SELECT_DESIGN.COMPONENT2.data);

        temp2.style.position  = "absolute";
        temp2.style.height    = this.DISPLAY_HEIGHT+"px";
        temp2.style.width     = this.DISPLAY_WIDTH+"px";
        temp2.style.left      = "0px";
        temp2.style.top       = this.DISPLAY_HEIGHT+"px";
        temp2.style.transform = "rotate(180deg)";

        const page_div = document.createElement("div");
        page_div.style.position  = "absolute";
        page_div.style.height    = ((this.DISPLAY_HEIGHT*2)+2)+"px"; //2px 더하면 되는건가
        page_div.style.width     = this.DISPLAY_WIDTH+"px";
        page_div.style.left      = "0px";
        page_div.style.top       = "0px";
        //page_div.style.overflow  = "hidden";

        page_div.appendChild(temp1);
        page_div.appendChild(temp2);

        const top_div = document.createElement("div");
        top_div.appendChild(page_div);

        var printContents = top_div.innerHTML;
        

        var w = window.open();

        //폰트정보 넘겨주기
        this.fontlist.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });

        w.document.write(printContents);
        w.document.write('<scr' + 'ipt type="text/javascript">' + 'window.onload = function() { window.print(); window.close(); };' + '</sc' + 'ript>');
        w.document.body.setAttribute("style", "-webkit-print-color-adjust: exact;");  //이거 해줘야 컬러와 이미지 출력됨.
        w.document.close(); // necessary for IE >= 10
        w.focus();

      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.SEARCH_STEP_NAME = "";
          this.SEARCH_STEP_IDX  = null;

          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          this.$session.set("STEP_IDX", null);
          this.$session.set("STEP_NAME", "");
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_STEP_NAME = "";
          this.SEARCH_STEP_IDX  = null;

          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.$session.set("STEP_IDX", null);
          this.$session.set("STEP_NAME", "");
        }
        this.drback.clearBackground();
        this.drback2.clearBackground();
        this.loadpage();

      },

      //검색조건 스텝 설정
      stepsearchcb(val1){
        
        if(val1 != null){
          this.SEARCH_STEP_NAME = val1.STEP_NAME;
          this.SEARCH_STEP_IDX  = val1.IDX;
          this.$session.set("STEP_IDX", val1.IDX);
          this.$session.set("STEP_NAME",val1.STEP_NAME);
        }else{
          this.SEARCH_STEP_NAME = "";
          this.SEARCH_STEP_IDX  = null;
          this.$session.set("STEP_IDX", null);
          this.$session.set("STEP_NAME", "");
        }

        this.drback.clearBackground();
        this.drback2.clearBackground();
        this.loadpage();
      },


      //base64 이미지 데이터를 파일로 변환
      dataURLtoFile(dataurl, fileName){
 
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], fileName, {type:mime});

      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.SEARCH_STEP_IDX = null;
          this.SEARCH_STEP_NAME = '';

        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;

          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';

          this.SEARCH_STEP_IDX = null;
          this.SEARCH_STEP_NAME = '';

        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("STEP_IDX", null);
        this.$session.set("STEP_NAME", "");

        this.drback.clearBackground();
        this.drback2.clearBackground();

        this.loadpage();
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.drback.clearBackground();
          this.drback2.clearBackground();

          this.loadpage();

      },

    },

    beforeRouteLeave (to, from, next) {
      
      var undocnt1 = this.drback.getUndoSize();
      var undocnt2 = this.drback2.getUndoSize();
      if(undocnt1+undocnt2 > 0){
        this.$confirm(this.$t('design_msg10'))
        .then(() => {
          next();
        });
      }else{
        next();
      }
    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      //리사이즈 이벤트
      window.addEventListener('resize', this.changelayoutsize);

      //edit_div에 DRBackground컴포넌트를 넣어준다.
      const edit_div = document.getElementById("edit_div");
      const edit_div2 = document.getElementById("edit_div2");
      
      const bg = new DRModel();
      bg.LAYOUT_WIDTH   = 384;
      bg.LAYOUT_HEIGHT  = 463;
      bg.LAYOUT_POSX    = 0;
      bg.LAYOUT_POSY    = 0;
      bg.ISBG           = 1;  //bg
      bg.COMPONENT_TYPE = 0; 
      bg.BGTYPE = 0;
      bg.BGCOLOR = "FFFFFFFF";
      this.drback  = new DRBackground(bg, this.SELECT_ITEM, this, true);
      this.drback2 = new DRBackground(bg, this.SELECT_ITEM, this, false);
      edit_div.appendChild(this.drback.back_div);
      edit_div2.appendChild(this.drback2.back_div);

      this.SELECT_ITEM.splice(0,1,bg);
      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.SEARCH_STEP_IDX   = this.$session.get("STEP_IDX");
      this.SEARCH_STEP_NAME  = this.$session.get("STEP_NAME");      
      this.grade = this.$session.get("GRADE");

      this.changelayoutsize();

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인 해야해
        this.$router.push("Login");
        return;
      }

      //폰트 읽기
      this.$http.post(this.$host+'/api/FontList',{
        search_keyword:""
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

              const list = result.data.resultData;
              this.fontlist.splice(0, this.fontlist.length);   //데이터 초기화
              list.forEach(element => {
                //폰트 등록
                var temp_font = new FontFace(element.NAME, "url('"+element.FONTURL+"')");
                document.fonts.add(temp_font);
                this.fontlist.push(temp_font);
              });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
          
      });


    },

    beforeDestroy(){
      window.removeEventListener('resize', this.changelayoutsize);
    },

    computed: {
    },

    watch: {

    },

    data () {
      
      return {
        useInfo:{},
        //dr background
        drback: null,
        drback2: null,

        //파일 업로드
        uploadFile : null,
        
        checkmove : false,
        bgcolorvalue : "00000000",
        textcolorvalue : "00000000",

        loading : false,    //로딩 표시

        
        items: [],

        SELECT_ITEM: [{}],  //서브 클래스에 참조타입으로 넘길려면 배열로 넘겨야 참조가 됨.
        DISPLAY_WIDTH:384,
        DISPLAY_HEIGHT:463,
        DISPLAY_X:0,
        DISPLAY_Y:0,
        
        BGTYPELIST: [
            {name:'컬러', name2:"Color",   value:0}
          , {name:'이미지', name2:"Image", value:1}
        ],

        ALIGNTYPELIST: [
            {name:'왼쪽',  name2:"Left",  value:"LEFT"}
          , {name:'오른쪽', name2:"Right", value:"RIGHT"}
          , {name:'가운데', name2:"Center", value:"CENTER"}
        ],

        COMPONENTTYPELIST: [
            {name:'텍스트', name2:"Text", value:1}
          , {name:'이미지', name2:"Image", value:0}
          , {name:'QR코드', name2:"QRCode", value:2}
          , {name:'포토',   name2:"Photo", value:3}
          , {name:'바코드', name2:"Barcode", value:4}
        ],

        MATCHTYPELIST: [
        ],

        isfront: true,      //명찰의 앞뒤 구분
        SELECT_DESIGN:null, //선택된 행사의 명찰디자인 객체

        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',
        SEARCH_STEP_IDX: null,
        SEARCH_STEP_NAME: '',
        grade : 0,

        fontlist: [],

      }
    }
  }
</script>
<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>  
  
  li {
    display: inline;
  }

  .pagination{
    margin: 0px;
  }
  
  
  body {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
  
  @media print {
      * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
      }
  }



</style>
